export enum ReportDownloadTypes {
   Html = 'text/html',
   Pdf = 'application/pdf',
   Excel = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
